import React from "react";
import { cn } from "../lib/utils";

export const SubcategoryBar = ({ subcategories, activeSub, onSelect }) => {
  if (!subcategories || subcategories.length === 0) return null;

  return (
    <div className="w-full bg-background/50 backdrop-blur-sm border-b sticky top-20 z-30" data-testid="subcategory-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-4 py-4 overflow-x-auto no-scrollbar">
          <button
            onClick={() => onSelect(null)}
            className={cn(
              "px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap",
              !activeSub 
                ? "bg-primary text-white shadow-lg shadow-primary/20" 
                : "bg-muted/50 hover:bg-muted text-muted-foreground"
            )}
          >
            All Packages
          </button>
          {subcategories.map((sub) => (
            <button
              key={sub.slug}
              onClick={() => onSelect(sub.slug)}
              className={cn(
                "px-5 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap border border-transparent",
                activeSub === sub.slug
                  ? "bg-primary text-white shadow-lg shadow-primary/20"
                  : "bg-muted/50 hover:bg-muted text-muted-foreground hover:border-primary/20"
              )}
            >
              {sub.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
